// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 352) return "static/chunks/352-80609885ae64989b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"112":"layout__minimal","136":"datadog_browser_logs","368":"b8fbd430","818":"layout__client_site_chrome_ui"}[chunkId] || chunkId) + "." + {"91":"1172a02d28cc711e","112":"b20c5eb44eebb6c7","136":"b81c9cb5c5435c86","368":"1c0cc7375caf9c40","522":"fcf130927e7bfca7","809":"4f417741ad260c44","818":"34b0819327a89156"}[chunkId] + ".js";
};